import React, { Component, useEffect, useState } from 'react'
import shortid from "shortid";
import { Link } from 'react-router-dom';
import "./LinkOnly.css"


const LinkOnly = ({ articleObj, param }) => {
  var content = articleObj;
    
    const [pathUrl, setPathUrl] = useState("")

    useEffect(() => {
      var url= window.location.pathname;
      setPathUrl(url)
     
    }, [])
    
    return (
<>
<div className="col-8 mx-auto"  data-type="LinkOnly" >
  <div className={`${content.attributes.linkUrlCss}`}>
    {content.attributes.linkUrl ?
      <Link className={`${content.attributes.linkUrl==pathUrl?"selected-link":''} faq-menus `} target={content.attributes.openLinkInNewTabYn === "true" ? "_blank" : ""} to={content.attributes.linkUrl}> 
        {content.attributes.linkName}
      </Link>
        :""}
  </div>
</div>
</>
    )
}

export default LinkOnly
